import { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import styled from 'styled-components';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { Field, Label, Input } from '../../components/ui/FormControls';
import { ErrorMessage, Spinner } from '../../components/ui/Feedback';
import { useAuth } from '../../context/AuthContext';

const Wrap = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
`;

const LoginCard = styled(Card)`
  width: 100%;
  max-width: 380px;
`;

const Title = styled.h1`
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: 1.8rem;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  text-align: center;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 1.5rem;

  &::after {
    content: '';
    display: block;
    width: 40px;
    height: 3px;
    background: ${({ theme }) => theme.colors.gold};
    margin: 0.5rem auto 0;
  }
`;

function AdminLogin() {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) {
    return <Navigate to="/admin/reservaciones" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(usuario, password);
      navigate('/admin/reservaciones', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrap>
      <LoginCard as="form" onSubmit={handleSubmit}>
        <Title>Panel Admin</Title>
        {error && <ErrorMessage role="alert">{error}</ErrorMessage>}
        <Field>
          <Label htmlFor="usuario">Usuario</Label>
          <Input
            id="usuario"
            required
            autoFocus
            value={usuario}
            onChange={(e) => setUsuario(e.target.value)}
          />
        </Field>
        <Field>
          <Label htmlFor="password">Contraseña</Label>
          <Input
            id="password"
            required
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Field>
        <Button type="submit" disabled={loading} style={{ width: '100%' }}>
          {loading ? <Spinner $size="18px" /> : 'Entrar'}
        </Button>
      </LoginCard>
    </Wrap>
  );
}

export default AdminLogin;
